import { AllowedResourceAlias, AllowedResourceInput } from './types';

export const getHospitalFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: hospitals(
    filter: {
      id: { in: $included_${alias}, notIn: $excluded_${alias} }
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getUnitFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: hospitalUnits(
    orderBy: ORDER_ASC
    filter: {
      id: { in: $included_${alias}, notIn: $excluded_${alias} }
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getFloorFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: floors(
    orderBy: ORDER_ASC
    filter: {
      visible: { equalTo: true }
      unitId: { in: $included_unit_${alias}, notIn: $excluded_unit_${alias} }
      id: { in: $included_${alias}, notIn: $excluded_${alias} }
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getSurveyFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: surveys(
    orderBy: NAME_ASC
    filter: {
      or: [{ id: { in: $included_${alias}, notIn: $excluded_${alias} } }]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getSurveyPageFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: surveyPages(
    orderBy: ORDER_ASC
    filter: {
      or: [{ id: { in: $included_${alias}, notIn: $excluded_${alias} } }]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name: title
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

// reason reason vem json de bson, tem que ver isso
export const getServiceFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: patientCallReasons(
    orderBy: ID_ASC
    filter: {
      or: [{ id: { in: $included_${alias}, notIn: $excluded_${alias} } }]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name: reason
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getServiceGroupFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: serviceGroups(
    orderBy: ID_ASC
    filter: {
      or: [{ id: { in: $included_${alias}, notIn: $excluded_${alias} } }]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getDepartmentsFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: hospitalDepartments(
    orderBy: ID_ASC
    filter: {
      or: [
        { id: { in: $included_${alias}, notIn: $excluded_${alias} } }
      ]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;

export const getFeedbackConfigFragment = (
  alias: AllowedResourceAlias,
  columns: AllowedResourceInput['columns'],
) => `
  ${alias}: feedbackConfigs(
    orderBy: NAME_ASC
    filter: {
      or: [{ id: { in: $included_${alias}, notIn: $excluded_${alias} } }]
    }
  ) @skip(if: $skip_${alias}) {
    nodes {
      id
      name
      ${columns?.map((column) => column).join(' ') || ''}
    }
  }
`;
